import { enableProdMode, provideZoneChangeDetection } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";

import { DashboardModule } from "./dashboardModule";
import { environment } from "./environments/environment";


if (environment.production)
{
    enableProdMode();
}

platformBrowserDynamic()
    .bootstrapModule(DashboardModule, { applicationProviders: [provideZoneChangeDetection()], })
    .catch(err => console.error(err));
